// AG Grid module registration (side effect) — must run before any DataGrid mounts.
import '@/components/grid/agGridModules';

import { createRoot } from 'react-dom/client';
import * as Sentry from '@sentry/react';
import { preloadLucideIcons, registerCustomIcons } from '@utilities-one/gpm-ui';

import { App } from '@/App';

import '@/assets/css/globals.css';
import '@/assets/css/form-surfaces.css';

void preloadLucideIcons();
void registerCustomIcons();

const sentryDsn = import.meta.env.VITE_SENTRY_DSN;

if (sentryDsn) {
  Sentry.init({
    dsn: sentryDsn,
    environment: import.meta.env.VITE_SENTRY_ENVIRONMENT,
    enabled: true,
    integrations: [Sentry.browserTracingIntegration(), Sentry.replayIntegration()],
    tracesSampleRate: 0.01,
    replaysSessionSampleRate: 0,
    replaysOnErrorSampleRate: 1.0,
    sendDefaultPii: true,
  });
}

const rootElement = document.getElementById('root');
if (!rootElement) {
  throw new Error('Failed to find the root element. Ensure index.html contains <div id="root"></div>');
}

createRoot(rootElement).render(<App />);
